//CRN_20260211 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { EncryptionService } from '../../general/encryption-service';
import { eSimApiPaths } from 'src/app/core/consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { MdmDevice_CompanyConfigDTO } from 'src/app/core/models/system/device-management/mdm-device-company-config.dto';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class MdmDevices_CompanyConfigService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
    
  public getByCompanyID(companyID: number): Observable<MdmDevice_CompanyConfigDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<MdmDevice_CompanyConfigDTO>(environment.eSimApi +
                                                                                          eSimApiPaths.MdmDevices_CompanyConfig + "/" +
                                                                                          eSimApiPaths.MdmDevices_CompanyConfigGetByCompanyID +
                                                                                          "?companyIdEncSS=" + companyIdEncSS, undefined); 
                                               })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
